export const SET_UTENTI_PAGEABLE = 'SET_UTENTI_PAGEABLE';
export const SET_UTENTI = 'SET_UTENTI';
export const SET_UTENTE = 'SET_UTENTE';
export const SET_NOTIFICHE = 'SET_NOTIFICHE';
export const SET_UTENTI_TAB = 'SET_UTENTI_TAB';